module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('AmendmentRequestDetails', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_external),
      expression: "is_external"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Return\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [(_vm.returns.has_species) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Species Available:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returns.species),
      expression: "returns.species"
    }],
    ref: "selected_species",
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.returns, "species", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.returns.species_list), function(specie, s_idx) {
    return _c('option', {
      key: ("specie_" + s_idx),
      staticClass: "change-species",
      attrs: {
        "species_id": s_idx
      },
      domProps: {
        "value": s_idx
      }
    }, [_vm._v(_vm._s(specie))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Do you want to Lodge a nil Return?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returns.nil_return),
      expression: "returns.nil_return"
    }],
    attrs: {
      "type": "radio",
      "id": "nilYes",
      "name": "nilYes",
      "value": "yes",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.returns.nil_return, "yes")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.returns, "nil_return", "yes")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "nilYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returns.nil_return),
      expression: "returns.nil_return"
    }],
    attrs: {
      "type": "radio",
      "id": "nilNo",
      "name": "nilNo",
      "value": "no",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.returns.nil_return, "no")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.returns, "nil_return", "no")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "nilNo"
    }
  }, [_vm._v("No")])]), _vm._v(" "), (_vm.nilReturn === 'yes') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Reason for providing a Nil return.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returns.nilReason),
      expression: "returns.nilReason"
    }],
    attrs: {
      "type": "textarea",
      "name": "nilReason"
    },
    domProps: {
      "value": (_vm.returns.nilReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.returns, "nilReason", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.nilReturn === 'no') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Do you want to upload spreadsheet with Return data?"), _c('br'), _vm._v("(Download "), _c('a', {
    attrs: {
      "href": _vm.returns.template
    }
  }, [_vm._v("spreadsheet template")]), _vm._v(")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spreadsheetReturn),
      expression: "spreadsheetReturn"
    }],
    attrs: {
      "type": "radio",
      "name": "SpreadsheetYes",
      "value": "yes",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.spreadsheetReturn, "yes")
    },
    on: {
      "change": function($event) {
        _vm.spreadsheetReturn = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "SpreadsheetYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spreadsheetReturn),
      expression: "spreadsheetReturn"
    }],
    attrs: {
      "type": "radio",
      "name": "SpreadsheetNo",
      "value": "no",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.spreadsheetReturn, "no")
    },
    on: {
      "change": function($event) {
        _vm.spreadsheetReturn = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "SpreadsheetNo"
    }
  }, [_vm._v("No")])]) : _vm._e(), _vm._v(" "), (_vm.nilReturn === 'no' && _vm.spreadsheetReturn === 'yes') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Do you want to add to existing data or replace existing data?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replaceReturn),
      expression: "replaceReturn"
    }],
    attrs: {
      "type": "radio",
      "name": "ReplaceYes",
      "value": "yes",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.replaceReturn, "yes")
    },
    on: {
      "change": function($event) {
        _vm.replaceReturn = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "ReplaceYes"
    }
  }, [_vm._v("Replace")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replaceReturn),
      expression: "replaceReturn"
    }],
    attrs: {
      "type": "radio",
      "name": "ReplaceNo",
      "value": "no",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.replaceReturn, "no")
    },
    on: {
      "change": function($event) {
        _vm.replaceReturn = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "ReplaceNo"
    }
  }, [_vm._v("Add to")])]) : _vm._e(), _vm._v(" "), (_vm.nilReturn === 'no' && _vm.spreadsheetReturn === 'yes') ? _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "btn btn-primary btn-file pull-left"
  }, [_vm._v("Upload File\n                    "), _c('input', {
    ref: "spreadsheet",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.uploadFile()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.uploadedFileName))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), (_vm.refreshGrid && _vm.nilReturn === 'no') ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.returns.table), function(data, key) {
    return _c('renderer-block', {
      key: ("returns-grid-data_" + key),
      attrs: {
        "component": data
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-left-20"
  })])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "table_name"
    },
    domProps: {
      "value": _vm.returns.table[0].name
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a508df2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/returns/enter_return.vue
// module id = 1036
// module chunks = 0